import sfFeatureFlagsService from '@simplifield/feature-flags';

export default angular
  .module('simplifield.feature-flags', [])
  .service('sfFeatureFlagsService', sfFeatureFlagsService).name;
